import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'table-column-ng-template',
  templateUrl: './table-column-ng-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnNgTemplateComponent<T> {
  @Input() template: TemplateRef<T>;

  @Input() element: T;

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = true;
}
